import React from 'react';
import '../../styles/explore.scss';

/**
 * Non-negotiable trust pattern: regulatory content must cite an official
 * source and show when it was last verified. See product vision.
 */
function OfficialCitation({
	sourceName,
	sourceUrl,
	lastVerified,
	subjectToChange = true,
	children,
}) {
	const formattedDate = lastVerified
		? new Date(lastVerified).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })
		: null;

	return (
		<div className={`official-citation${subjectToChange ? ' official-citation--live' : ''}`}>
			<div className="official-citation__header">
				<span className="official-citation__badge">
					{sourceUrl ? 'Official source' : 'Editorial — confirm officially'}
				</span>
				{formattedDate && (
					<span className="official-citation__verified">Last verified: {formattedDate}</span>
				)}
			</div>
			{children && <div className="official-citation__body">{children}</div>}
			{sourceUrl && (
				<p className="official-citation__link">
					Source:{' '}
					<a href={sourceUrl} target="_blank" rel="noopener noreferrer">
						{sourceName || sourceUrl}
					</a>
					{subjectToChange && ' — rules change. Always confirm current details before you travel.'}
				</p>
			)}
			{!sourceUrl && subjectToChange && (
				<p className="official-citation__warning">
					This section has not yet been linked to an official government source. Do not rely on it for legal or immigration decisions — check the official site directly.
				</p>
			)}
		</div>
	);
}

export default OfficialCitation;
